import { render, staticRenderFns } from "./AddModelModal.vue?vue&type=template&id=a7492d86&"
import script from "./AddModelModal.vue?vue&type=script&lang=js&"
export * from "./AddModelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports